import type { EditableCustomer, EditableCustomerUpdates } from './customerUpdateApi';

const API_BASE_URL = '/api';

export type NewCustomerPayload = EditableCustomerUpdates;

export interface CustomerCreateResult {
  customer: EditableCustomer | null;
  dataverseCustomerId: string;
  repairShoprCustomerId: number | string;
}

async function parseError(response: Response, fallback: string): Promise<Error> {
  const data = await response.json().catch(() => ({ error: `${fallback}: ${response.status}` }));
  return new Error(data.error || fallback);
}

export async function createCustomer(
  payload: NewCustomerPayload,
  signal?: AbortSignal,
): Promise<CustomerCreateResult> {
  const response = await fetch(`${API_BASE_URL}/customers`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
    signal,
  });

  if (!response.ok) {
    throw await parseError(response, 'Failed to create customer');
  }

  return response.json();
}
